

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../appstyles/SelectedCategory.css';



// Dynamic SelectedCategory component using category prop only
const SelectedCategory = ({ category, image }) => {

  const [data, setData] = useState(null);
  const [openSubs, setOpenSubs] = useState({});
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/products.json')
      .then((res) => res.json())
      .then((json) => setData(json));
  }, []);

  useEffect(() => {
    if (data && category && data[category]) {
      const allOpen = Object.keys(data[category]).reduce((acc, subcat) => {
        acc[subcat] = true;
        return acc;
      }, {});
      setOpenSubs(allOpen);
    }
  }, [data, category]);

  if (!data) return (
    <div className="selected-category text-center mt-5">
      <div className="spinner-border text-primary mb-3" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <h2>Loading...</h2>
    </div>
  );

  if (!category || !data[category]) {
    return (
      <div className="selected-category text-center mt-5">
        <h2>No data found for <span className="text-danger">{category}</span></h2>
      </div>
    );
  }

  const categoryData = data[category];

  const getFilteredProducts = (products) => {
    if (!search.trim()) return products;
    return products.filter((product) =>
      product.toLowerCase().includes(search.trim().toLowerCase())
    );
  };

  const handleSelect = (product) => {
    setSelected((prev) =>
      prev.includes(product)
        ? prev.filter((item) => item !== product)
        : [...prev, product]
    );
  };

  const handleCotizar = () => {
    if (selected.length === 0) return;
    const message = `Me gustaría cotizar los siguientes productos de la categoría ${category}:\n- ${selected.join("\n- ")}`;
    navigate('/contacto', { state: { prefillMessage: message, prefillSubject: 'Cotización a través de la web' } });
  };

  const toggleSub = (subcat) => {
    setOpenSubs((prev) => ({ ...prev, [subcat]: !prev[subcat] }));
  };

  if (Array.isArray(categoryData)) {
    const filtered = getFilteredProducts(categoryData);
    return (
      <div className="selected-category shadow-sm">
        {image && (
          <div className="selected-category-image-container">
            <img
              src={image}
              alt="Category Icon"
              className="selected-category-image"
            />
          </div>
        )}
        <h2 className="mb-4 selected-category-title">{category}</h2>
        <input
          type="text"
          className="form-control mb-3"
          placeholder="Buscar producto..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <ul className="product-list">
          {filtered.length === 0 ? (
            <li className="product-item text-muted">No products found</li>
          ) : (
            filtered.map((product) => (
              <li className="product-item" key={product}>
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  checked={selected.includes(product)}
                  onChange={() => handleSelect(product)}
                  id={`select-${product}`}
                />
                <label htmlFor={`select-${product}`} style={{cursor:'pointer'}}>{product}</label>
              </li>
            ))
          )}
        </ul>
        <button
          className="btn btn-success mt-3"
          disabled={selected.length === 0}
          onClick={handleCotizar}
        >
          Cotizar
        </button>
      </div>
    );
  }

  return (
    <div className="selected-category shadow-sm">
      {image && (
        <div className="selected-category-image-container">
          <img
            src={image}
            alt="Category Icon"
            className="selected-category-image"
          />
        </div>
      )}
      <h2 className="mb-4 selected-category-title">{category}</h2>
      <input
        type="text"
        className="form-control mb-3"
        placeholder="Buscar producto..."
        value={search}
        onChange={e => setSearch(e.target.value)}
      />
      <div className="subcategory-list">
        {Object.entries(categoryData).map(([subcat, products]) => {
          const filtered = getFilteredProducts(products);
          if (filtered.length === 0) return null;
          return (
            <div className="subcategory" key={subcat}>
              <h3 className="d-flex align-items-center mb-2" onClick={() => toggleSub(subcat)}>
                {openSubs[subcat] ? <ExpandMoreIcon /> : <ChevronRightIcon />} <span className="ms-2">{subcat}</span>
              </h3>
              {openSubs[subcat] && (
                <ul className="product-list">
                  {filtered.map((product) => (
                    <li className="product-item" key={product}>
                      <input
                        type="checkbox"
                        className="form-check-input me-2"
                        checked={selected.includes(product)}
                        onChange={() => handleSelect(product)}
                        id={`select-${subcat}-${product}`}
                      />
                      <label htmlFor={`select-${subcat}-${product}`} style={{cursor:'pointer'}}>{product}</label>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );
        })}
      </div>
      <button
        className="btn btn-success mt-3"
        disabled={selected.length === 0}
        onClick={handleCotizar}
      >
        Cotizar
      </button>
    </div>
  );
};

export default SelectedCategory;
